export default __webpack_public_path__ + "static/media/ts-poster-small.b99eb749.jpg";